import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AnNamElement } from '../../base-element.js';

/** Map of menu title → Shopify CDN image URL. */
const MENU_ICONS: Record<string, string> = {
  Beverages: 'https://cdn.shopify.com/s/files/1/0972/9992/3254/files/Beverages.svg',
  'Canned & Ready-to-Eat Foods': 'https://cdn.shopify.com/s/files/1/0972/9992/3254/files/Canned_Ready-to-Eat_Foods.svg',
  'Dry Goods & Pantry Staples': 'https://cdn.shopify.com/s/files/1/0972/9992/3254/files/Dry_Goods_Pantry_Staples.svg',
  'Frozen Food': 'https://cdn.shopify.com/s/files/1/0972/9992/3254/files/Frozen_food.svg',
  'Household & Cooking Essentials':
    'https://cdn.shopify.com/s/files/1/0972/9992/3254/files/Household_Cooking_Essentials.svg',
  'Instant Noodles': 'https://cdn.shopify.com/s/files/1/0972/9992/3254/files/Instant_Noodles.svg',
  'Premium/ Japanese/ Korean/ Philippines': 'https://cdn.shopify.com/s/files/1/0972/9992/3254/files/Premium_Products.svg',
  'Rice & Grains': 'https://cdn.shopify.com/s/files/1/0972/9992/3254/files/Rice_Grains.svg',
  'Sauces & Condiments': 'https://cdn.shopify.com/s/files/1/0972/9992/3254/files/Sauces_Condiments.svg',
  'Snack & Sweets': 'https://cdn.shopify.com/s/files/1/0972/9992/3254/files/Snacks_Sweets.svg',
};

@customElement('an-menu-icon')
export class AnMenuIcon extends AnNamElement {
  /** Menu item title to match against the icon map. */
  @property({ type: String, attribute: 'item-title' }) itemTitle = '';

  override render() {
    const src = MENU_ICONS[this.itemTitle];
    if (!src) {
      this.style.display = 'none';
      return html``;
    } else {
      this.style.display = '';
      return html`<img src="${src}" alt="${this.itemTitle}" width="20" height="20" loading="lazy" />`;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'an-menu-icon': AnMenuIcon;
  }
}
